import { z } from 'zod';
import { CURRENCY_CODE_REGEX } from './currency.constants';

export const currencyCodeSchema = z
  .string()
  .trim()
  .toUpperCase()
  .regex(CURRENCY_CODE_REGEX, 'Currency code must be exactly 3 letters (e.g., USD, EUR, GBP)');

export const saveCurrencyRequestSchema = z.object({
  currencyCode: currencyCodeSchema,
});

export const saveCurrencyResponseSchema = z.object({
  success: z.boolean(),
  error: z.string().optional(),
  data: z
    .object({
      currencyCode: currencyCodeSchema,
      dmi: z.unknown().nullable(),
      cgi: z.unknown().nullable(),
    })
    .optional(),
});

export const currencyOptionSchema = z.object({
  value: z.string(),
  label: z.string(),
});

export const preferencesResponseSchema = z
  .object({
    CompensationCurrency: z.string().optional(),
    CompensationCurrencyDescription: z.string().optional(),
    CompensationCurrencySymbol: z.string().optional(),
    compensationCurrency: z.string().optional(),
    currency: z.string().optional(),
    Email1MonthlyNewsletter: z.union([z.boolean(), z.number(), z.string()]).optional(),
    Email2EmailUpdates: z.union([z.boolean(), z.number(), z.string()]).optional(),
    Email33rdParty: z.union([z.boolean(), z.number(), z.string()]).optional(),
    DailyNewsletter: z.union([z.boolean(), z.number(), z.string()]).optional(),
    daily_newsletter: z.union([z.boolean(), z.number(), z.string()]).optional(),
    NAEmailUpdates: z.union([z.boolean(), z.number(), z.string()]).optional(),
    AAEmailUpdates: z.union([z.boolean(), z.number(), z.string()]).optional(),
    AISWeeklyNewsletter: z.union([z.boolean(), z.number(), z.string()]).optional(),
    ais_weekly_newsletter: z.union([z.boolean(), z.number(), z.string()]).optional(),
  })
  .refine(
    (data) => {
      return Object.keys(data).length > 0;
    },
    {
      message: 'PreferencesResponse must contain at least one field',
    },
  );

export const currenciesApiResponseSchema = z.object({
  success: z.boolean().optional(),
  data: z
    .union([
      z.array(z.string()),
      z.array(
        z.object({
          code: z.string().optional(),
          Code: z.string().optional(),
          Currency: z.string().optional(),
        }),
      ),
    ])
    .optional(),
});

export type CurrencyCode = z.infer<typeof currencyCodeSchema>;
export type SaveCurrencyRequest = z.infer<typeof saveCurrencyRequestSchema>;
